import { useMediaQuery } from '@material-ui/core';

const useDeviceType = () => {
  let isMobile = useMediaQuery('(max-width:1500px)');

  let isTablet = useMediaQuery('(max-width:2200px)');
  const userAgent = navigator.userAgent;
  if (
    !userAgent.match(/Android/i) &&
    !userAgent.match(/webOS/i) &&
    !userAgent.match(/iPhone|iPad|iPod/i) &&
    !userAgent.match(/iPad/i) &&
    !userAgent.match(/Tablet/i)
  ) {
    isMobile = false;
    isTablet = false;
  }

  return { isMobile, isTablet };
};

export default useDeviceType;

// import { useMediaQuery } from '@material-ui/core';

// // scale factor 0.36

// const useDeviceType = () => {
//   const isMobile = useMediaQuery('(max-width:1500px)');

//   const isTablet = useMediaQuery('(max-width:2200px)');

//   return { isMobile, isTablet };
// };

// export default useDeviceType;
